import { getItemDecrypt } from "../../utils/cryptoData";

export default function createPdFTable(data) {
  // const vinculoAtivo = JSON.parse(localStorage.getItem('vinculo_ativo'))
  // const usuario = JSON.parse(localStorage.getItem('usuario'))
  const vinculoAtivo = getItemDecrypt("vinculo_ativo");
  const usuario = getItemDecrypt("usuario");

  let dadosIdentificacaoList = [];
  let header = [];
  for (let k = 1; k < Object.keys(data.columns).length - 1; k++) {
    header.push({
      text: `${data.columns[k].headerName}`,
      style: "tableExample",
    });
  }

  dadosIdentificacaoList.push(header);

  const statusDescricaoExists =
    data.columns.filter((column) => column.field === "statusDescricao").length >
    0;
  if (statusDescricaoExists) {
    for (let k = 0; k < Object.keys(data.rows).length; k++) {
      dadosIdentificacaoList.push([
        { text: `${data.rows[k].nome}`, style: "tableExample" },
        { text: `${data.rows[k].dataOuHorario}`, style: "tableExample" },
        { text: `${data.rows[k].cpf}`, style: "tableExample" },
        { text: `${data.rows[k].statusDescricao}`, style: "tableExample" },
        { text: `${data.rows[k].telefone}`, style: "tableExample" },
      ]);
    }
  } else {
    for (let k = 0; k < Object.keys(data.rows).length; k++) {
      dadosIdentificacaoList.push([
        { text: `${data.rows[k].nome}`, style: "tableExample" },
        { text: `${data.rows[k].dataOuHorario}`, style: "tableExample" },
        { text: `${data.rows[k].dtNascimento}`, style: "tableExample" },
        { text: `${data.rows[k].cpf}`, style: "tableExample" },
        { text: `${data.rows[k].telefone}`, style: "tableExample" },
      ]);
    }
  }

  return [
    {
      text: `Prontuário Eletrônico para Pacientes com ELA \n \n`,
      style: "subTitle",
    },
    {
      layout: "noBorders", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        widths: ["35%", "65%"],
        height: [10],

        body: [
          [
            { text: "Gerado por: ", style: "tableExample", bold: true },
            { text: `${usuario.no_nome_usuario}`, style: "tableExample" },
          ],
          [
            { text: "Perfil:", style: "tableExample", bold: true },
            { text: `${vinculoAtivo.perfil.nome}`, style: "tableExample" },
          ],
          [
            { text: "Município: ", style: "tableExample", bold: true },
            {
              text: `${vinculoAtivo.municipio.nome}/${vinculoAtivo.uf.sigla}`,
              style: "tableExample",
            },
          ],
          [
            {
              text: "Estabelecimento de Saúde: ",
              style: "tableExample",
              bold: true,
            },
            {
              text: `${vinculoAtivo.estabelecimento.nome}`,
              style: "tableExample",
            },
          ],
        ],
      },
    },
    {
      text: `\n Listagem de ${data.titulo.toLowerCase()} \n`,
      style: "subTitle",
    },
    {
      layout: "lightHorizontalLines", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["25%", "20%", "20%", "20%", "20%"],
        height: [10],

        body: dadosIdentificacaoList,
      },
    },
  ];
}
